import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import type { ICleanHtmlProps } from './types';

export const replaceEntities = ( text: string ) => {
    return text
        .replace( /&quot;/g, '"' )
        .replace( /&gt;/g, '>' )
        .replace( /&lt;/g, '<' )
        .replace( /&amp;/g, '&' );
};

export const cleanHtmlString = ( props: ICleanHtmlProps ) => {
    const allowedTags = props.allowedTags || [ 'p', 'div', 'h1', 'h2', 'h3', 'a', 'img', 'i', 'b', 'em', 'strong', 'br' ];
    const allowedAttributes = props.allowedAttributes || { a: [ 'href' ] };
    const decodeEntities = true;
    return sanitizeHtml( replaceEntities( props.html ), { allowedTags, allowedAttributes, decodeEntities } );
};

export const cleanHtmlDecodeString = ( () => {
    const element = document.createElement( 'div' );

    const decodeHtmlEntities = ( encodedHtml?: string ): string => {
        if ( !encodedHtml || typeof encodedHtml !== 'string' ) {
            return encodedHtml as string;
        }

        const strippedHtml = encodedHtml
            .replace( /<script[^>]*>([\S\s]*?)<\/script>/gmi, '' )
            .replace( /<\/?\w(?:[^"\'>]|"[^"]*\"|\'[^']*\')*>/gmi, '' );

        element.innerHTML = strippedHtml;
        const decodedHtml = element.textContent;
        element.textContent = '';

        return decodedHtml;
    };

    return decodeHtmlEntities;
} )();

export const CleanHtml: React.FC<ICleanHtmlProps> = ( props: ICleanHtmlProps ) => {
    const Wrapper = props.wrapperElement || 'div';
    const clean = cleanHtmlString( props );

    return (
        <Wrapper
            className={ props.className }
            style={ props.style }
            dangerouslySetInnerHTML={ { __html: clean } }
        />
    );
};
